import AkIconSearch from '@atlaskit/icon/glyph/search';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

const modeConfig = Immutable.Map({
  header: Immutable.Map({ className: 'header-search', iconSize: 'medium' }),
  hero: Immutable.Map({ className: 'hero-search', iconSize: 'large' }),
});

export default class TextSearch extends Component {
  static propTypes = {
    focusOnMount: PropTypes.bool,
    mode: PropTypes.oneOf(['header', 'hero']),
    name: PropTypes.string,
    query: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    focusOnMount: false,
    mode: 'hero',
    onChange: () => {},
  };

  componentDidMount() {
    if (this.props.focusOnMount) {
      this.searchBox.focus();
    }
  }

  onChange = ({ target: { value } }) => {
    this.props.onChange(value);
  };

  render() {
    return (
      <div className={`text-search ${modeConfig.getIn([this.props.mode, 'className'])}`}>
        <input
          className="search-box"
          ref={input => (this.searchBox = input)}
          name={this.props.name}
          type="text"
          placeholder="Search for apps"
          onChange={this.onChange}
          value={this.props.query}
        />
        <span className="search-glass">
          <AkIconSearch label="Search" size={modeConfig.getIn([this.props.mode, 'iconSize'])} />
        </span>
      </div>
    );
  }
}
